const translations = {
    applicationDetails: 'Application Details',
    fileUpload: 'File Upload',
    flightOverview: 'Flight Overview',
    uploadAFlightLog: 'Upload a Flight Log'
};

export default translations;
